export class ContactMe {
    name: string = '';
    title: string = '';
    email: string = '';
    phone: string = '';
    location: string = '';
    linkedin: string = '';
    github: string = '';
}